import { render } from "./AboutSimp.vue?vue&type=template&id=31c306db"
import script from "./AboutSimp.vue?vue&type=script&lang=js"
export * from "./AboutSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__